const STORAGE_KEY = 'fvs-login-failed-attempts';
export const MAX_FAILED_ATTEMPTS = 5;
export const ATTEMPT_WINDOW_MS = 15 * 60 * 1000;
export const LOGIN_COOLDOWN_MS = 15 * 60 * 1000;

export function getLoginCooldown(storage, now = Date.now()) {
  try {
    const saved = JSON.parse(storage.getItem(STORAGE_KEY) || '{}');
    const blockedUntil = Number(saved.blockedUntil) || 0;
    if (blockedUntil > now) {
      return { attempts: MAX_FAILED_ATTEMPTS, blockedUntil };
    }
    const attempts = (Array.isArray(saved.attempts) ? saved.attempts : [])
      .filter((time) => Number.isFinite(time) && time > now - ATTEMPT_WINDOW_MS && time <= now);
    return { attempts: attempts.length, blockedUntil: 0, attemptTimes: attempts };
  } catch {
    return { attempts: 0, blockedUntil: 0, attemptTimes: [] };
  }
}

export function recordFailedLogin(storage, now = Date.now()) {
  const current = getLoginCooldown(storage, now);
  if (current.blockedUntil) return current;

  const attemptTimes = [...current.attemptTimes, now];
  const blockedUntil = attemptTimes.length >= MAX_FAILED_ATTEMPTS ? now + LOGIN_COOLDOWN_MS : 0;
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify({ attempts: attemptTimes, blockedUntil }));
  } catch { /* Firebase's own abuse protection still applies if browser storage is unavailable. */ }
  return { attempts: attemptTimes.length, blockedUntil };
}

export function clearLoginCooldown(storage) {
  try { storage.removeItem(STORAGE_KEY); } catch { /* best effort */ }
}
